import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

import { CalendarToday } from '@material-ui/icons';
import moment from 'moment';

import { Select, Autocomplete } from '~/components/Form';
import { t } from '~/helpers';
import api from '~/services/api';

import { Card } from '..';

import { Form } from './styles';

export default function History() {
  const [data, setData] = useState([]);
  const [initials, setInitials] = useState();

  /**
   * request data in URL
   *
   * @param {Object} params
   */
  async function handleData(params) {
    const request = await api.get('dashboardshistoricosabastecimentos', {
      params,
    });

    await setData(request.data);
    await setInitials(params || { periodo: '7' });
  }

  useEffect(() => {
    handleData();
  }, []);

  return (
    <Card
      icon={<CalendarToday />}
      title={t('s.dashboard.dashvolumeabastecimento.historicodeabastecimento')}
      onSubmit={(value) => handleData(value)}
      initials={initials}
      filter={
        <Form>
          <Select
            name="periodo"
            label={t('s.dashboard.dashvolumeabastecimento.periodo')}
            options={[
              {
                value: '7',
                label: t('s.dashboard.dashvolumeabastecimento.ultimasemana'),
              },
              {
                value: '15',
                label: t('s.dashboard.dashvolumeabastecimento.ultimos15dias'),
              },
              {
                value: '30',
                label: t('s.dashboard.dashvolumeabastecimento.ultimos30dias'),
              },
            ]}
          />

          <Autocomplete
            name="idposto"
            label="nomeposto"
            url="postoscomboios"
            unique="idposto"
            title={t('s.configuracao.arqueacao.idposto')}
          />

          <Autocomplete
            name="idproduto"
            label="nomeproduto"
            url="produtos"
            unique="idproduto"
            title={t('s.menu.configuracao.produto')}
          />
        </Form>
      }
    >
      <Chart
        series={[
          {
            name: t('s.dashboard.dashvolumeabastecimento.volumeabastecido'),
            data: data.map((item) => item.volumeabastecido),
          },
          {
            name: t('s.dashboard.dashvolumeabastecimento.saldoestoque'),
            data: data.map((item) => item.saldoestoque),
          },
        ]}
        options={{
          chart: {
            toolbar: {
              show: false,
            },
            height: 230,
            type: 'area',
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
          },
          xaxis: {
            type: 'date',
            categories: data.map((item) =>
              moment(item.datahora, 'DD/MM/YYYY').format('DD/MM/YYYY')
            ),
          },
          tooltip: {
            x: {
              format: 'dd/MM/yyyy',
            },
          },
        }}
        type="area"
        height="230"
      />
    </Card>
  );
}
